// Currency + date formatting helpers (Indian rupee conventions).

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

const inrPaiseFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format integer paise as ₹. Values are rounded to whole rupees unless paise matter. */
export function formatINR(paise: number | null | undefined): string {
  if (paise === null || paise === undefined) return "—";
  const hasPaise = Math.abs(paise % 100) !== 0;
  return hasPaise ? inrPaiseFormatter.format(paise / 100) : inrFormatter.format(paise / 100);
}

/** Format with exact paise (for settlement transparency). */
export function formatINRExact(paise: number | null | undefined): string {
  if (paise === null || paise === undefined) return "—";
  return inrPaiseFormatter.format(paise / 100);
}

export function rupeesToPaise(rupees: number): number {
  return Math.round(rupees * 100);
}

export function paiseToRupeesNumber(paise: number | null | undefined): number {
  if (paise === null || paise === undefined) return 0;
  return paise / 100;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "To be decided";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "To be decided";
  return d.toLocaleString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "To be decided";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "To be decided";
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
}

export function formatDeadline(iso: string | null | undefined): string {
  if (!iso) return "No deadline set";
  return `Closes ${formatDateTime(iso)}`;
}

export function percent(value: number): string {
  return `${Math.round(value * 10) / 10}%`;
}

export function statusLabel(status: string): string {
  switch (status) {
    case "planning":
      return "Planning";
    case "voting_open":
      return "Voting open";
    case "finalized":
      return "Finalized";
    case "completed":
      return "Completed";
    case "cancelled":
      return "Cancelled";
    case "draft":
      return "Draft";
    case "open":
      return "Voting open";
    case "scheduled":
      return "Opens soon";
    case "closed":
      return "Closed";
    default:
      return status;
  }
}
